if (!customElements.get('facet-drawer')) {
  customElements.define('facet-drawer', class FacetDrawer extends MainDrawer {
    constructor() {
      super();                  
      
      this.setFocus = debounce((event) => {
        trapFocus(document.querySelector('.drawer--active'), document.querySelector('.drawer--active'))              
      }, 300);

      this.querySelectorAll('.drawer-close').forEach(el => el.addEventListener('click', () => this.closeDrawer()));    
      this.closest('.facet-container').querySelector('.facet__trigger').addEventListener('click', (e) => {        
        e.preventDefault()
        loadScript('facets')
        loadCss('facets')    
        this.openDrawer()      
        this.setFocus()
      });      
    }        
  });
}

// get the sticky element
const stickyElm = document.querySelector('.toolbar--sticky')

const stickyElementObserver = new IntersectionObserver( 
  ([e]) => {      
    if(e.intersectionRatio < 1){        
      e.target.classList.add('isSticky')        
    } else {        
      e.target.classList.remove('isSticky')
    }      
  },
  {threshold: [1]}
);

// stickyElementObserver.observe(stickyElm)


(()=>{

  let currFacetType = '';

  let = sortFacet = {
            "id": "0",
            "field": "sort",
            "type": "terms",
            "name": "Sort by",
            "data": [
              {
                "value": "Alphabetically, A-Z",
                "count": 0,
                "selected": false
              },
              {
                "value": "Alphabetically, Z-A",
                "count": 0,
                "selected": false
              },
              {
                "value": "Price, low to high",
                "count": 0,
                "selected": false
              },
              {
                "value": "Price, high to low",
                "count": 0,
                "selected": false
              },
            ]
          }

  getNostoCollectionhResults({by: 'none', order: 'none'}, [], true);


  function getNostoCollectionhResults(sort = {by: 'none', order: 'none'}, filters = []) {


    let query = `query($categoryId: String) {
                search(
                  accountId: "shopify-10561394"		
                  products: { 
                    size: 400, 
                    categoryId: $categoryId,
                    preFilter: [],
                    filter: []
                    },
                ) {
                  products {
                    hits {
                      available
                      productId
                      name
                      url
                      thumbUrl
                      imageUrl
                      alternateImageUrls
                      price
                      listPrice
                      priceCurrencyCode
                      datePublished
                      tags1
                      customFields {
                        key
                        value
                      }
                    }
                    facets {
                      ... on SearchTermsFacet {
                      id
                      field
                      type
                      name
                      data {
                        value
                        count
                        selected
                      }
                    }

                  }
                }
              }
            }`;

    let variables = {
      categoryId: collectionId,
    }

    let paramArr = window.location.search.slice(1).split('&');

    let filterQuery = [];
    let sortQueryStr = `{}`;
    paramArr.forEach(param => {
      if(param.includes('Filter.')){
        let field = decodeURIComponent(param.split('=')[0].replace('Filter.','')).replaceAll('+', ' ');
        let value = decodeURIComponent(param.split('=')[1]).replaceAll('+', ' ');
        //console.log('field')
        //console.log(field)

        if(filterQuery.some(filter => filter.field == field)){
          let filterIndex = filterQuery.findIndex(filter => filter.field == field);
          //console.log(filterIndex)
          //console.log(filterQuery[filterIndex])
          filterQuery[filterIndex].value.push(value) 
        } else {
          filterQuery.push({ field: field, value: [value]})
        }
      } 
      if (param.includes('sort=')){
        let sortField = param.split('=')[1].split('-')[0];
        let sortOrder = param.split('=')[1].split('-')[1];
        sortQueryStr =`{field: "${sortField}", order: ${sortOrder} }`
      }
    })

    if(filterQuery.length == 0 && sortQueryStr == `{}`){
      //shopify plp
      //console.log('shopify plp')
      //document.getElementById('product-grid').style.display = 'grid';
      //document.getElementById('nosto-collection-ul').style.display = 'none'        
    } else {
      //console.log('nosto plp')
      //document.getElementById('product-grid').style.display = 'none';
      //document.getElementById('nosto-collection-ul').style.display = 'flex'
    }

    let filterQueryStr =  JSON.stringify(filterQuery).replaceAll(`"field"`, 'field').replaceAll(`"value"`, 'value')

    query = query.replace('filter: []', 'filter: ' + filterQueryStr)

    if(sortQueryStr != '{}') {
      query = query.replace('400,', '400, sort: ' + sortQueryStr + ',')
    }

    query.replace('filter', '')

    //console.log('filterQuery')
    //console.log(filterQuery)
    //console.log('sortQuery')
    //console.log(sortQueryStr)
    //console.log('query')
    //console.log(query)


    let collectionFacetsQuery = `query($categoryId: String) {
      search(
        accountId: "shopify-10561394"
        products: { size: 400, categoryId: $categoryId }
      ) {
        products {
          facets {
            ... on SearchTermsFacet {
              id
              field
              type
              name
              data {
                value
                count
                selected
              }
            }
          }
        }
      }
    }`

    //fetch('https://search.nosto.com/v1/graphql', {
      //method: 'POST',
      //headers: {
        //'Content-Type': 'application/json',
      //},
      //body: JSON.stringify({
        //query: collectionFacetsQuery,
        //variables: variables,
      //}),
    //})
    //.then((res) => res.json())
    //.then((result) => {
      //let collectionFacets = result.data.search.products.facets;

      fetch('https://search.nosto.com/v1/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: query,
          variables: variables,
        }),
      })
      .then((res) => res.json())
      .then((result) => {
        console.log('nosto result')
        console.log(result)

        let isFilteredSorted = (sortQueryStr == '{}' && filterQueryStr == '[]')?false:true;

        renderNostoCollectionResults(result.data.search.products.hits, isFilteredSorted)


        //renderNostoCollectionFacets(result.data.search.products.facets, collectionFacets);
        let facets = result.data.search.products.facets

        facets.unshift(sortFacet)
        renderNostoCollectionFacets(facets);
        renderNostoCollectionFacetsMobile(facets);
        details()
        addFilterButtonListeners();

        
        
        
        /*Nosto.migrateToShopifyMarket({
          productSectionElement: '.grid__item',
          productTitleElement: '.x-nosto-title',
          productUrlElement: '.nosto-product-url',
          productHandleAttribute: 'x-nosto-handle',
          priceElement: '.price-item',
          listPriceElement: '.price-item--list',
        })*/

  /*
        renderNostoSearchResults(result.data.search.products.hits, searchTerm, result.data.search.products.total)


        let resultProducts = [];  
        result.data.search.products.hits.forEach(el => {
          resultProducts.push({ productId: el.productId})
        })

      */ 
        
     // })

      let resultProducts = [];  
      result.data.search.products.hits.forEach(el => {
        resultProducts.push({ productId: el.productId})
      })
        
      let interval,
      counter = 0,
      duration = 250,
      limit = 40;
      interval = setInterval( () => {
        if (typeof nostojs != 'undefined') {
          //console.log('nostojs found')
          //console.log(sortQueryStr)
          //console.log(counter)         
          nostojs(api => {
            api.recordSearch(
              "category",
              {
                products: {
                  categoryId: `${ShopifyAnalytics.meta.page.resourceId}`,
                  categoryPath: collectionPath,
                  sort: [sortQueryStr],
                  from: 0
                }
              },
              {
                products: {
                  categoryId: `${ShopifyAnalytics.meta.page.resourceId}`,
                  categoryPath: collectionPath,
                  hits: resultProducts,
                  fuzzy: true,
                  total: resultProducts.length,
                  from: 0
                }
              },
              {
                isKeyword: false  
              }   
            )
          })    

          clearInterval( interval );
        } else if ( counter === limit ) {
          clearInterval ( interval );
        } 
      }, duration ); 

      Array.from(document.getElementsByClassName('product-grid-section')[0].getElementsByClassName('nosto-product-url')).forEach(el => {
        el.addEventListener('click', e => {
          //e.preventDefault();
          //console.log('click')
          nostojs(api => {
            api.recordSearchClick(
              "category", 
              { productId: e.currentTarget.id, url: e.currentTarget.href }
            )
          })
        })
      })

    })


  }

  // const filterByTags = (hits, tagArray) => {

  //   let filteredHits = [];
  //   hits.forEach(hit => {
  //     tagArray.forEach( tag => {
  //       if(hit.tags1.length){                 
  //         let hitTagArr = hit.tags1.map(t => t.toLowerCase());
  //         if(hitTagArr.includes(tag.toLowerCase()) ){
  //           filteredHits.push(hit);
  //         }
  //       }  
  //     })
  //   })

  //   return filteredHits;
  // }


  function renderNostoCollectionResults (hits, isFilteredSorted) {
    //console.log('hits')
    //console.log(hits)
    let html = ``;

    hits.forEach((hit, i) => {
      // if not filter or sort add look blocks
      if(!isFilteredSorted){
        html += lookBlock(i);
      }
      //product card
      html += jsGridItem(hit);
    });
    document.getElementById('nosto-collection-ul').innerHTML = html;
    addMediaScrollListeners();
  }


  function renderNostoCollectionFacets (currFacets) {
    //console.log('currFacets-------------')
    //console.log(currFacets)
    //console.log('colFacets-------------')
    //console.log(colFacets)
    
    if(document.getElementsByClassName('nosto-filters-form').length > 0){
      document.getElementsByClassName('nosto-filters-form')[0].remove()
    }
    // Facet Types
    let facetTypesHtml = `<ul class="facet-filters__types-container">`
    //facetTypesHtml += renderSortByType();
    //facetTypesHtml += renderAvailableType();

    currFacets.forEach( facet => {
      //if(facet.name.toLowerCase() == "size" || facet.name.toLowerCase() == "product color"){
      if(facet.hasOwnProperty('data')) {
        facetTypesHtml += renderFilterType(facet);
      }
      //}
    })

    facetTypesHtml += `</ul>`
    // end Facet Types
    ////////////////
    ////////////////

    // Facet Filters
    let facetFiltersHtml = `<ul class="facet-filters__filters-container" id="">`
    //facetFiltersHtml += renderSortByType();

    currFacets.forEach( (facet, i) => {
      //if(facet.name.toLowerCase() == "size" || facet.name.toLowerCase() == "product color"){
      if(facet.hasOwnProperty('data')) {
        facetFiltersHtml += renderFilter(facet, i);
      }
      //}

    })
    
    facetFiltersHtml += `</ul>`
    // end Filter Types


    let filtersFormHtml = `<div class="nosto-filters-form flex">`
    filtersFormHtml += facetTypesHtml; 
    filtersFormHtml += facetFiltersHtml;
    filtersFormHtml += `</div>` 
    document.getElementsByTagName('facet-filters-form')[0].style.display = 'none';
    document.getElementsByTagName('facet-drawer')[0].getElementsByClassName('drawer__body')[0].insertAdjacentHTML('beforeend', filtersFormHtml)

    if(currFacetType != ''){
      Array.from(document.getElementsByClassName('facet-filters__filter')).forEach(el => {
        el.style.display = 'none';
      })
      document.getElementById(currFacetType).style.display = 'block';
      document.getElementById('Type-'+ currFacetType).classList.add('active');
    }

  }

  function renderFilterType(facet){
    //if(!facet.hasOwnProperty('data')) {
      //return;
    //}
    let selectedCount = 0;

      facet.data.forEach(filter => {
        if(filter.selected == true){
          selectedCount++;
        }
      })
    let display = 'display: none;';
    if(selectedCount > 0){
      display = '';
    }

      return `
      <li class="facet-filters__type link-styled--grey" data-filter="${facet.field}" aria-current="false" id="Type-Filter-${facet.id}">
        <span class="icon-active" aria-hidden="true"></span>
        <button class="btn btn--unstyled" type="button" aria-controls="Filter-${facet.id}">
          ${facet.name}
          <span class="active-filters-size__split" style="${display}">/ </span>
          <span class="active-filters-size" style="${display}">${selectedCount}</span>
        </button>
      </li>
      `

  } 


  function renderFilter (facet, i){
    let filterHtml = `<li class="facet-filters__filter" data-index="${i}" data-filter="${facet.id}" aria-expanded="true" id="Filter-${facet.id}">
      <fieldset>
        <legend class="visually-hidden">Filter by ${facet.name}</legend>
        <ul>`;
    if(facet.hasOwnProperty('data')) {
      facet.data.forEach((option, i) => {
        filterHtml += renderFilterOption(facet, option, i);
      })
    }
    
          
    filterHtml += `</ul>
      </fieldset>
    </li>`;
    return filterHtml;

    function renderFilterOption(facet, option, i){
      let checked = '';
      if(option.selected == true){
        checked = 'checked';
      }
      if(facet.field == 'sort'){
        if(window.location.search.includes(valueMap(option.value))){
          checked = 'checked';
        }
      }
      let filterOrSortPrefix = 'Filter.';
      if(facet.field == "sort"){
        filterOrSortPrefix = '';
      }
      return `<li class="facet-filters__filter-item facet-filters__is-filter link-styled--grey container" data-filter="${facet.field}">
            <input class="facets__checkbox" type="checkbox" name="${facet.field}" value="${encodeURIComponent(option.value)}" id="Filter-${facet.id}-${i}" role="button" tabindex="0" ${checked}>
            <label for="Filter-${facet.id}-${i}" class="facets__label swatch-wrapper container body-2" data-value="${valueMap(option.value)}" data-filter="${filterOrSortPrefix}${facet.field}">
              <span class="icon-active" aria-hidden></span>
              <span>${displayedValueMap(option.value, facet)}</span>
              <span class="visually-hidden" aria-hidden="true">${option.value} (${option.count} products)</span>
            </label>
          </li>`

    }
  }

  function addFilterButtonListeners(){

    // add filter type listeners
    Array.from(document.getElementsByClassName('facet-filters__type')).forEach( filterType => {
      let btn = filterType.getElementsByTagName('button')[0];
      filterType.addEventListener('click', e => {
        // hide all
        Array.from(document.getElementsByClassName('facet-filters__filter')).forEach(el => {
          el.style.display = 'none';
        })
        // show only selected
        document.getElementById(btn.getAttribute('aria-controls')).style.display = 'block';
        currFacetType = btn.getAttribute('aria-controls');

        // show dot next to active type
        Array.from(document.getElementsByClassName('facet-filters__type')).forEach(el => {
          el.classList.remove('active');
        })
        document.getElementById('Type-' + currFacetType).classList.add('active');
      })
    })

    // add filter listeners

    Array.from(document.getElementsByClassName('facets__label')).forEach(el => {
      el.addEventListener('click', e => {
        //console.log(el.dataset.value)
        //console.log(el.dataset.filter)
        let filter = el.dataset.filter.replaceAll(' ', '+');
        let value = el.dataset.value.replaceAll(' ', '+');

        const url = new URL(window.location);


        if(url.searchParams.has(filter, value)){
          url.searchParams.delete(filter, value);
        } else {
          if(filter == 'sort'){
            url.searchParams.set(filter, value)
          } else {
            url.searchParams.append(filter, value)
          }
        }


        history.pushState(null, '', url);

        setTimeout(()=>{
          getNostoCollectionhResults();
        }, 500);

      })
    })

  }

  function valueMap(value){
    if(value == 'Alphabetically, A-Z'){
      return 'name-desc'
    }
    if(value == 'Alphabetically, Z-A'){
      return 'name-asc'
    }
    if(value == 'Price, low to high'){
      return 'price-asc'
    }
    if(value == 'Price, high to low'){
      return 'price-desc'
    }
    if(value == 'Date, old to new'){
      return 'datePublished-desc'
    }
    if(value == 'Date, new to old'){
      return 'datePublished-asc'
    }
    return value;
  }


  function displayedValueMap(value, facet) {
    if(facet.field == "available"){
      if(value == "true"){
        return "In Stock"
      }
      if(value == "false"){
        return "Out of Stock"
      }
    }
    return value;
  }



  function renderNostoCollectionFacetsMobile (currFacets) {
    //console.log('currFacets-------------')
    //console.log(currFacets)
    //console.log('colFacets-------------')
    //console.log(colFacets)

    if(document.getElementsByClassName('nosto-filters-form--mobile').length > 0){
      document.getElementsByClassName('nosto-filters-form--mobile')[0].remove()
    }
    // Facet Types
    let facetTypesHtml = ``

    currFacets.forEach( (facet, i) => {
      //if(facet.name.toLowerCase() == "size" || facet.name.toLowerCase() == "product color"){

      let filtersHTML = renderFilterMobile(facet, i);

      if(facet.hasOwnProperty('data')) {
        facetTypesHtml += renderFilterTypeMobile(facet, i, filtersHTML);
      }
      //}
    })

    // end Facet Types
    ////////////////
    ////////////////

    // Facet Filters
    let facetFiltersHtml = `<ul class="facet-filters__filters-container" id="">`
    //facetFiltersHtml += renderSortByType();

    currFacets.forEach( (facet, i) => {
      //if(facet.name.toLowerCase() == "size" || facet.name.toLowerCase() == "product color"){
      if(facet.hasOwnProperty('data')) {
        facetFiltersHtml += renderFilter(facet, i);
      }
      //}

    })
    
    facetFiltersHtml += `</ul>`
    // end Filter Types


    let filtersFormHtml = `<div class="nosto-filters-form--mobile">`
    filtersFormHtml += facetTypesHtml; 
    filtersFormHtml += `</div>` 
    document.getElementsByTagName('facet-filters-form')[1].style.display = 'none';
    document.getElementsByTagName('facet-drawer')[1].getElementsByClassName('drawer__body')[0].insertAdjacentHTML('beforeend', filtersFormHtml)

    if(currFacetType != ''){
      Array.from(document.getElementsByClassName('facet-filters__filter')).forEach(el => {
        el.style.display = 'none';
      })
      document.getElementById(currFacetType).style.display = 'block';
      document.getElementById('Type-'+ currFacetType).classList.add('active');
    }

  }

  function renderFilterTypeMobile(facet, i, filtersHtml){
    //if(!facet.hasOwnProperty('data')) {
      //return;
    //}
    let selectedCount = 0;

      facet.data.forEach(filter => {
        if(filter.selected == true){
          selectedCount++;
        }
      })
    let display = 'display: none;';
    if(selectedCount > 0){
      display = '';
    }

      return `
      <div class="details filter__item" data-index="${i}" data-filter="${facet.field}">
        <button type="button" class="btn btn--unstyled summary facets__summary content--full-width flex jcb aic">
          <span>${facet.name}<span class="active-filters-size__split" style="${display}"> / </span><span class="active-filters-size" style="${display}">${selectedCount}</span></span>
          <svg class="icon icon--caret" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.666585 4L7.99992 12L15.3333 4" stroke="black"></path>
          </svg>
        </button>
        <div class="details__content">
          <ul class="list-unstyled details__content-inner mobile-list--${facet.field.replaceAll('.','-').replaceAll(' ', '-')}" role="list">
          ${filtersHtml}
          </ul>
        </div>
      </div>
      `

  } 

  function renderFilterMobile (facet, i){
    let filterHtml = ``
    if(facet.hasOwnProperty('data')) {
      facet.data.forEach((option, i) => {
        filterHtml += renderFilterOptionMobile(facet, option, i);
      })
    }
    return filterHtml;

    function renderFilterOptionMobile(facet, option, i){
      let checked = '';
      if(option.selected == true){
        checked = 'checked';
      }
      if(facet.field == 'sort'){
        if(window.location.search.includes(valueMap(option.value))){
          checked = 'checked';
        }
      }
      let filterOrSortPrefix = 'Filter.';
      if(facet.field == "sort"){
        filterOrSortPrefix = '';
      }
      return `
        <li class="facet-filters__filter-item facet-filters__is-filter link-styled--grey container" data-filter="${facet.field}">
          <input class="facets__checkbox" type="checkbox" name="${facet.field}" value="${encodeURIComponent(option.value)}" id="Filter-mobile-${facet.id}-${i}" role="button" tabindex="0" ${checked}>
          <label for="Filter-mobile-${facet.id}-${i}" class="facets__label swatch-wrapper container body-2" data-value="${valueMap(option.value)}" data-filter="${filterOrSortPrefix}${facet.field}">
            <span class="icon-active" aria-hidden></span>
            <span>${displayedValueMap(option.value, facet)}</span>
            <span class="visually-hidden" aria-hidden="true">${option.value} (${option.count} products)</span>
          </label>
        </li>`

    }
  }



function details(){ //init details - copied from main.js - must init after render for mobile accordions
  // Details animation
  document.querySelectorAll('.drawer--filter .details .summary').forEach((summary) => {      
    const details = summary.closest('.details');
    summary.addEventListener('click', (event) => {        
      details.classList.toggle('details--active');
      
      if(details.classList.contains('details--active')){
        summary.setAttribute('aria-expanded', true);
      } else {
        summary.setAttribute('aria-expanded', false);
      }      
    });   

    // Disable details functionality on desktop
    const mobileOnlyDetails = (summary) => {
      const details = summary.closest('.details');

      if(details.classList.contains('mobile--only')) {            
        if(window.innerWidth < 769){
          details.removeAttribute('open')
          details.classList.remove('details--active')         
          summary.setAttribute('aria-expanded', false)        
        } else {
          details.setAttribute('open', '')
          details.classList.add('details--active')
          summary.setAttribute('aria-expanded', true)        
        }      
      }     
    }
    
    window.addEventListener('DOMContentLoaded', mobileOnlyDetails(summary))    
  });
}

})();



function lookBlock(index) {
  //let block = null; 
  let blockArr = lookBlocks.filter(block => block.settings.block_position - 1 == index )


  if(blockArr.length > 0){
    //console.log(blockArr)
    let block = blockArr[0];
    let media = '';
    let height = "1350";
    if(block.settings.banner_height == "1"){
      height = "675";
    }

    if(block.settings.asset_options == 'image'){
      media = `<img 
        loading="lazy" 
        src="${block.settings.image}&width=1080" 
        alt="" 
        width="1080" 
        height="${height}" 
        style="--image-focal: middle"
      >` 
    } else {
      if(block.settings.video_url != ''){
        media = `
         <video
          src="${block.setttings.video_url }"
          loop
          muted
          playsinline
          autoplay
        ></video>`
      }
    }

    // let linkButton = '';

    // if(block.settings.button_text != '' ){
    //   if(block.settings.button_link != '' ){
    //     linkButton = `<a
    //       class="shop-the-look__collection-cta btn btn--tertiary"
    //       href="${block.settings.button_link}"
    //     >
    //       ${block.settings.button_text}
    //     </a>`
    //   } else {
    //     linkButton = `<button
    //       class="shop-the-look__collection-cta btn btn--tertiary"
    //       data-shop-look-id="${block.id}"
    //     >
    //       ${block.settings.button_text}
    //     </button>`
    //   }
    // }

    let html = `<li class="shop-the-look__collection" style="--banner-height: ${block.settings.banner_height}">
        <div class="shop-the-look__collection-inner">
          ${media}
        </div>
      </li>`
    return html;

  } else {
    return '';
  }
}